export function handleCovertPhone (phone) {
  return `${phone}`.replace(/\s+/g, '').replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
}
